import React, { createContext, useContext, useEffect, useState } from "react";
import { getEarningsData } from "@/api/base";
import { Earnings } from "@/types/referals";
import { useUserInfoStore } from "@/store/userInfoStore";

interface EarningsContextValue {
  earningsLoading: boolean;
  earnings: Earnings;
}

const defaulEarnings = {
  balance: 0,
  total: { earned: 0, total_possible: 0 },
  active: { earned: 0, total_possible: 0 },
  missed: { earned: 0, total_possible: 0 },
};

const EarningsContext = createContext<EarningsContextValue | undefined>(
  undefined
);

export const EarningsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [earningsLoading, setEarningsLoading] = useState<boolean>(true);
  const [earnings, setEarnings] = useState<Earnings>({} as Earnings);
  const yandexId = useUserInfoStore((s) => s.yandexId);

  const loadData = async () => {
    try {
      setEarningsLoading(true);

      const res = await getEarningsData(yandexId);
      setEarnings(res);
    } catch (e) {
      setEarnings(defaulEarnings);
      console.log(e);
    } finally {
      setEarningsLoading(false);
    }
  };

  useEffect(() => {
    if (!yandexId) {
      setEarnings(defaulEarnings);
      setEarningsLoading(false);
      return;
    }

    loadData();
  }, [yandexId]);

  return (
    <EarningsContext.Provider value={{ earningsLoading, earnings }}>
      {children}
    </EarningsContext.Provider>
  );
};

export const useEarningsDataContext = (): EarningsContextValue => {
  const ctx = useContext(EarningsContext);
  if (!ctx) {
    throw new Error(
      "useEarningsDataContext must be used within EarningsProvider"
    );
  }
  return ctx;
};
